import { render, staticRenderFns } from "./landscapeScreen.vue?vue&type=template&id=98697c8a&scoped=true"
import script from "./landscapeScreen.vue?vue&type=script&lang=js"
export * from "./landscapeScreen.vue?vue&type=script&lang=js"
import style0 from "./landscapeScreen.vue?vue&type=style&index=0&id=98697c8a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98697c8a",
  null
  
)

export default component.exports